import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import DataMigrationTab from '@/pages/admin/DataMigrationTab'

const dataMigrationSearchSchema = z.object({
  view: z.enum(['overview', 'browser']).optional(),
  entity: z.string().optional(),
})

export const Route = createFileRoute('/_authenticated/admin/system/data-migration')({
  validateSearch: dataMigrationSearchSchema,
  component: DataMigrationTab,
})
